import React, { useEffect, useState } from "react";
import styles from "../../Styles/forgotpassword/styles.module.css";
import bubbles from "../../images/bubble.png";
import bubble from "../../images/Ellipse 13.png";
import TextField from "@mui/material/TextField";
import { forgotPassword } from "../../helper/authApiCalls/auth";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import bubbles2 from "../../images/Bubbles (1).svg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  function onSubmit() {
    setError("");
    setSuccess(false);

    const sendBody = {
      email: email,
    };

    forgotPassword(sendBody).then((data) => {
      console.log(data);
      if (data.status === "fail") {
        setError(data.message);
      } else {
        setSuccess(true);
      }
    });
  }

  let navigate = useNavigate();

  const successComponent = () => {
    return (
      <div className={styles.success}>
        <div>
          <p>We have mailed you password reset email.</p>
          <span>Please check your mail for resetting your password</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (isAuthenticated()) {
      return navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ForgotPasswordPage = () => {
    return (
      <div className="text">
        <div className={styles.mainbody}>
          <div className={styles.rightflank}>
            <div className={styles.fig}>
              <img src={bubbles} alt="%" />
            </div>

            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.downspans}>
              <div className={styles.upspan}>
                <span>Grow by learning</span>
                <img src={bubble} alt="" />
              </div>
              <div className={styles.downspan}>
                <span>
                  We strive to help and bring together the online learners community by compiling
                  knowledgeable resources from all over the internet.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.leftflank}>
            <div className={styles.mainlog}>
              <span>Forgot Password?</span>
              <span className={styles.mailtext}>
                Enter the email associated with this account to reset your password.
              </span>
            </div>
            <div className={styles.in}>
              {!success ? (
                <div>
                  <div className={styles.in1}>
                    <TextField
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button onClick={onSubmit}>Continue</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Don't have an account? </span>
                      <a href="/signup">Sign up</a>
                    </div>
                  </div>
                </div>
              ) : (
                <div>{successComponent()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const ForgotPasswordMobile = () => {
    return (
      <div>
        <div className="text">
          <div className={styles.mobilecontainer}>
            <div className={styles.bubblecontain}>
              <img src={bubbles2} alt="%" />
            </div>
            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.in}>
              <div className={styles.head}>
                <span>Forgot Password?</span>
                <span className={styles.mailtext}>
                  Enter the email associated with this account to reset your password.
                </span>
              </div>
              {!success ? (
                <div>
                  <div className={styles.in1}>
                    <TextField
                      label="Email"
                      type="email"
                      id="outlined-size-small"
                      size="small"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button onClick={onSubmit}>Continue</button>
                  </div>
                  <div className={styles.info}>
                    <div className={styles.info1}>
                      <span>Don't have an account? </span>
                      <a href="/signup">Sign up</a>
                    </div>
                  </div>
                </div>
              ) : (
                <div>{successComponent()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {ForgotPasswordPage()}
      {ForgotPasswordMobile()}
    </div>
  );
};

export default ForgotPassword;
